import { Injectable } from '@angular/core';
import { StageService } from '../../../../stage.service';

declare const THREE: any;

@Injectable()
export class InfillsKindsUtilsService {
  constructor(private stageService: StageService) { }

  getPointWithTheSameY(mainPoint, pointToConvert) {
    return pointToConvert.clone().setY(mainPoint.y);
  }

  clipInfillMaterialByFourPoints(firstPoint, secondPoint, thirdPoint, fourthPoint, materials, needLeftRight?) {
    const clippingPlanes = [];

    const firstPointToSecondPoint = this.getPointWithTheSameY(firstPoint, secondPoint).sub(
      firstPoint
    );

    const firstPlaneCoplanarPoint = firstPoint
      .clone()
      .add(firstPointToSecondPoint.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2));

    clippingPlanes.push(
      new THREE.Plane().setFromCoplanarPoints(firstPoint, secondPoint, firstPlaneCoplanarPoint)
    );

    /////

    const secondPointToFirstPoint = this.getPointWithTheSameY(secondPoint, firstPoint).sub(
      secondPoint
    );

    const secondPlaneCoplanarPoint = secondPoint
      .clone()
      .add(secondPointToFirstPoint.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2));

    if (needLeftRight) {
      clippingPlanes.push(
        new THREE.Plane().setFromCoplanarPoints(thirdPoint, secondPoint, secondPlaneCoplanarPoint)
      );
    }

    /////

    const thirdPointToFourthPoint = this.getPointWithTheSameY(thirdPoint, fourthPoint).sub(
      thirdPoint,
      fourthPoint
    );

    const thirdPlaneCoplanarPoint = thirdPoint
      .clone()
      .add(thirdPointToFourthPoint.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2));

    clippingPlanes.push(
      new THREE.Plane().setFromCoplanarPoints(thirdPoint, fourthPoint, thirdPlaneCoplanarPoint)
    );

    /////

    const fourthPointToThirdPoint = this.getPointWithTheSameY(fourthPoint, thirdPoint).sub(
      firstPoint
    );

    const fourthlaneCoplanarPoint = fourthPoint
      .clone()
      .add(fourthPointToThirdPoint.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2));

    if (needLeftRight) {
      clippingPlanes.push(
        new THREE.Plane().setFromCoplanarPoints(fourthPoint, firstPoint, fourthlaneCoplanarPoint)
      );
    }

    // const helpers = new THREE.Group();
    // helpers.add(new THREE.PlaneHelper(clippingPlanes[0], 1000, 0xff0000));
    // helpers.add(new THREE.PlaneHelper(clippingPlanes[1], 1000, 0x00ff00));
    // helpers.add(new THREE.PlaneHelper(clippingPlanes[2], 1000, 0x0000ff));
    // helpers.add(new THREE.PlaneHelper(clippingPlanes[3], 1000, 0x0000ff));
    // this.stageService.add(helpers);
    materials.forEach(material => {
      material.clippingPlanes = clippingPlanes;
      material.clipIntersection = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/infills/kinds/tools/infills-kinds-utils.service.ts